
import BaseComponent from './BaseComponent';

export default class SidebarController extends BaseComponent
{
    constructor() {
        super();

        this.doc = document;

        this.sidebarContainer = null;

        this.header = null;

        this.content = null;

        this.newContainerHeight = 0;

        this.isInitEvent = false;

        this.init();
    }

    init() {
        this.sidebarContainer = this.doc.querySelector('.blb-sidebar-controller');
        this.header = this.sidebarContainer.querySelector('.blb-box-header');
        this.content = this.sidebarContainer.querySelector('.blb-box-content');

        window.addEventListener('resize', this.handleResize.bind(this));

        this.handleResize();
    }

    handleResize() {
        if (!this.isInitEvent) {
            if (window.innerWidth >= 1280) {
                // this.sidebarContainer.removeAttribute('style');
                this.newContainerHeight = this.header.offsetHeight + this.content.offsetHeight;

                this.sidebarContainer.setAttribute('style', 'max-height:'+(this.newContainerHeight)+'px;');
            // } else {
            //     if (this.sidebarContainer.hasAttribute('style')) this.sidebarContainer.removeAttribute('style');
            }

            this.isInitEvent = true;
        } else {
            return;
        }
    }
}
